export const enum DocumentTheme {
  LIGHT = "light",
  DARK = "dark",
  FUN = "fun",
}

export const DocumentThemeDef = {
  [DocumentTheme.LIGHT]: {
    logo: "/static/nextwork-icon.svg",
    background: "bg-white",
    font: "text-[#101828]",
    frame: "bg-[#F8F5F1]",
  },
  [DocumentTheme.DARK]: {
    logo: "/static/nextwork-icon-white.svg",
    background: "bg-[#1B1918]",
    font: "text-white",
    frame: "bg-[#383231]",
  },
  [DocumentTheme.FUN]: {
    logo: "/static/nextwork-icon.svg",
    background: "bg-white",
    font: "text-[#101828]",
    frame: "bg-[url('/static/images/documentation/fun-preview-background.svg')] bg-no-repeat bg-cover",
  },
};
